<template>
  <div class="rs-searchresults__vue__main">
    <div class="rs-searchresults__vue__main__heading__filters">
      <div class="rs-searchresults__vue__main__heading__filters__tabs">
        <div
          class="rs-searchresults__vue__main__heading__filters__tabs__button"
          :class="
            selectedSortBy === 'relevance' &&
            'rs-searchresults__vue__main__heading__filters__tabs__button__is-selected'
          "
        >
          <button
            :disabled="selectedSortBy === 'relevance'"
            @click="$emit('sortby-change-request', 'relevance')"
            v-html="strings['By Relevance']"
          />
        </div>

        <div
          class="rs-searchresults__vue__main__heading__filters__tabs__separator"
        >
          |
        </div>

        <div
          class="rs-searchresults__vue__main__heading__filters__tabs__button"
          :class="
            selectedSortBy === 'newest' &&
            'rs-searchresults__vue__main__heading__filters__tabs__button__is-selected'
          "
        >
          <button
            :disabled="selectedSortBy === 'newest'"
            @click="$emit('sortby-change-request', 'newest')"
            v-html="strings['Newest First']"
          />
        </div>

        <div
          class="rs-searchresults__vue__main__heading__filters__tabs__separator"
        >
          |
        </div>

        <div
          class="rs-searchresults__vue__main__heading__filters__tabs__button"
          :class="
            selectedSortBy === 'oldest' &&
            'rs-searchresults__vue__main__heading__filters__tabs__button__is-selected'
          "
        >
          <button
            :disabled="selectedSortBy === 'oldest'"
            @click="$emit('sortby-change-request', 'oldest')"
            v-html="strings['Oldest First']"
          />
        </div>
      </div>

      <div
        class="rs-searchresults__vue__main__heading__filters__showing"
        v-if="fetchedResults.total_posts > 0"
      >
        {{ fetchedResults.total_posts }}
        <span
          v-if="fetchedResults.total_posts === 1"
          v-html="strings['Result']?.toLowerCase()"
        />
        <span v-else v-html="strings['Results']?.toLowerCase()" />
      </div>

      <div
        class="rs-searchresults__vue__main__heading__filters__showing"
        v-else
      >
        <!-- Nothing found -->
      </div>
    </div>
    <hr />

    <RSSearchResultsGrid :fetchedResults="fetchedResults" />

    <hr v-if="totalPages > 1" style="margin-bottom: 16px" />

    <RSPagination
      v-if="totalPages > 1"
      :totalPages="totalPages"
      :currentPage="currentPage"
      :strings="strings"
      @page-changed="onPageChanged"
    />
  </div>
</template>

<script>
import RSSearchResultsGrid from "./RSSearchResultsGrid.vue";
import RSPagination from "../RSPagination.vue";

export default {
  components: {
    RSSearchResultsGrid,
    RSPagination,
  },
  props: {
    fetchedResults: Object,
    selectedSortBy: String,
    strings: Object,
    totalPages: Number,
    currentPage: Number,
  },
  methods: {
    onPageChanged(page) {
      this.$emit("page-change-request", page);
    },
  },
};
</script>
